import { render } from "./messages.vue?vue&type=template&id=75e2dbf2"
const script = {}
script.render = render

export default script